export default "__VITE_ASSET__BFrx77se__";